import type { SWRConfiguration } from "swr";
import { GetHelpTopicsRequest, GetHelpTopicsResponse, HelpTopic } from "src/api/Tmd.dtos";
import useBaseLoadCollection from "../useBaseLoadCollection";
const useHelpTopics = (
    configuration?: SWRConfiguration<GetHelpTopicsResponse, GetHelpTopicsResponse> | null,
) =>
    useBaseLoadCollection<HelpTopic, GetHelpTopicsResponse, GetHelpTopicsRequest>(
        GetHelpTopicsRequest,
        configuration,
    );
export default useHelpTopics;
